import { stringify } from "qs";
import GATEWAY from "@/utils/gateway";
import request from "../utils/request";

const preUrl = GATEWAY;
const preUrlOfSponsor = `${preUrl}sponsor`;
const conversionMockUrl =
  "https://nei.netease.com/api/apimock/b54c1df644544c1fe79cfcb9d1c4d935";
const promotionMockUrl =
  "https://nei.netease.com/api/apimock/5d54d74341e46c0100fd9dec09d36d9f";

// 并发抑制
const economize = (action) => {
  const running = {}
  const done = (key, status) => (result) => {
      running[key] = null
      delete running[key]
      return Promise[status](result)
  }
  return (payload) => {
      const key = JSON.stringify(payload)
      // eslint-disable-next-line no-return-assign
      return running[key] || (
          running[key] = action(payload)
              .then(done(key, 'resolve'))
              .catch(done(key, 'reject'))
      )
  }
}

/* home start */
export async function fetchHomeFund() {
  return request(`${preUrlOfSponsor}/sponsor/fund/info`, {
    method: "POST",
  });
}

export async function fetchHomeStat(params) {
  return request(`${preUrlOfSponsor}/sponsor/statistic`, {
    method: "POST",
    body: params,
  });
}

export async function fetchHomeStatTrend(params) {
  return request(`${preUrlOfSponsor}/sponsor/statistic/trend`, {
    method: "POST",
    body: params,
  });
}

export async function fetchHomeStatTrendSingle(params) {
  return request(`${preUrlOfSponsor}/adform/query/trend`, {
    method: "POST",
    body: params,
  });
}

export async function fetchEnable(params) {
  return request(`${preUrlOfSponsor}/adform/query/enable`, {
    method: "POST",
    body: params,
  });
}

export async function createSponsorApply(params) {
  return request(`${preUrlOfSponsor}/sponsorApply/create`, {
    method: "POST",
    body: params,
  });
}
/* home end */

/* finance start */
export async function fetchFinanceList(params) {
  return request(`${preUrlOfSponsor}/sponsor/fund/detailList`, {
    method: "POST",
    body: params,
  });
}

export async function exportData(params) {
  return request(`${preUrlOfSponsor}/sponsor/fund/downLoadList`, {
    method: "POST",
    body: params,
  });
}

export async function getExportStatus(params) {
  return request(`${preUrlOfSponsor}/sponsor/fund/getExportStatus`, {
    method: "POST",
    body: params,
  });
}

export async function killExportTask(params) {
  return request(`${preUrlOfSponsor}/sponsor/fund/killExportTask`, {
    method: "POST",
    body: params,
  });
}
/* finance end */

/* promote start */
export async function fetchPlan(params) {
  return request(`${preUrlOfSponsor}/adPlan/query/list`, {
    method: "POST",
    body: params,
  });
}

export async function exportPlan(params) {
  return request(`${preUrlOfSponsor}/adPlan/exportByDay`, {
    method: "POST",
    body: params,
  });
}

export async function getExportPlanStatus(params) {
  return request(`${preUrlOfSponsor}/adPlan/getExportStatus`, {
    method: "POST",
    body: params,
  });
}

export async function cancelExportPlan(params) {
  return request(`${preUrlOfSponsor}/adPlan/killExportTask`, {
    method: "POST",
    body: params,
  });
}

export const fetchPlanInfo = economize(async (params) => {
  return request(`${preUrlOfSponsor}/adPlan/query/info`, {
    method: "POST",
    body: params,
  });
})

export async function fetchAd(params) {
  return request(`${preUrlOfSponsor}/adform/query/list`, {
    method: "POST",
    body: params,
  });
}

export async function exportAd(params) {
  return request(`${preUrlOfSponsor}/adform/exportByDay`, {
    method: "POST",
    body: params,
  });
}

export async function getExportAdStatus(params) {
  return request(`${preUrlOfSponsor}/adform/getExportStatus`, {
    method: "POST",
    body: params,
  });
}
export async function cancelExportAd(params) {
  return request(`${preUrlOfSponsor}/adform/killExportTask`, {
    method: "POST",
    body: params,
  });
}
export const fetchAdDetail = economize(async (params) => {
  return request(`${preUrlOfSponsor}/adform/query/info`, {
    method: "POST",
    body: params,
  });
});
// 是否有点击监测链接
export async function destinationUrlRequired(params) {
  return request(`${preUrlOfSponsor}/adform/destinationUrlRequired`, {
    method: "POST",
    body: params,
  });
}
// 是否有"有效播放监测链接"
export async function adCreateMeuShow(params) {
  return request(`${preUrlOfSponsor}/adform/adCreateMeuShow`, {
    method: "POST",
    body: params,
  });
}
export async function deepLinkAuth(params) {
  return request(`${preUrlOfSponsor}/adform/query/deepLinkAuth`, {
    method: "POST",
    body: params,
  });
}

export async function updatePlanName(params) {
  return request(`${preUrlOfSponsor}/adPlan/update/name`, {
    method: "POST",
    body: params,
  });
}

export async function updateAdName(params) {
  return request(`${preUrlOfSponsor}/adform/update/name`, {
    method: "POST",
    body: params,
  });
}

export async function updateAdPrice(params) {
  return request(`${preUrlOfSponsor}/adform/update/price`, {
    method: "POST",
    body: params,
  });
}

export async function pauseAdform(params) {
  return request(`${preUrlOfSponsor}/adform/update/pause`, {
    method: "POST",
    body: params,
  });
}

export async function serveAdform(params) {
  return request(`${preUrlOfSponsor}/adform/update/serve`, {
    method: "POST",
    body: params,
  });
}

export async function checkAdCountLimit() {
  return request(`${preUrlOfSponsor}/adform/checkAdCountLimit`, {
    method: "POST",
    body: {},
  });
}

export async function updatePlanLimit(params) {
  return request(`${preUrlOfSponsor}/adPlan/update/dailyBudget`, {
    method: "POST",
    body: params,
  });
}

export async function updatePlanServingMode(params) {
  return request(`${preUrlOfSponsor}/adPlan/update/servingMode`, {
    method: "POST",
    body: params,
  });
}

export async function pauseAdPlan(params) {
  return request(`${preUrlOfSponsor}/adPlan/update/pause`, {
    method: "POST",
    body: params,
  });
}

export async function serveAdPlan(params) {
  return request(`${preUrlOfSponsor}/adPlan/update/serve`, {
    method: "POST",
    body: params,
  });
}

export async function removeAdPlan(params) {
  return request(`${preUrlOfSponsor}/adPlan/delete`, {
    method: "POST",
    body: params,
  });
}

export async function removeAd(params) {
  return request(`${preUrlOfSponsor}/adform/delete`, {
    method: "POST",
    body: params,
  });
}


// 批量计划
export async function removePlanBatch(params) {
  return request(`${preUrlOfSponsor}/adPlan/batchdelete`, {
    method: "POST",
    body: params,
  });
}

// 批量删除计划
export async function pausePlanBatch(params) {
  return request(`${preUrlOfSponsor}/adPlan/update/batchpause`, {
    method: "POST",
    body: params,
  });
}

// 批量删除计划
export async function servePlanBatch(params) {
  return request(`${preUrlOfSponsor}/adPlan/update/batchserve`, {
    method: "POST",
    body: params,
  });
}



export async function fetchRtbInventory(params) {
  return request(`${preUrlOfSponsor}/inventory/rtb/query`, {
    method: "POST",
    body: params,
  });
}

export async function fetchCreativity(params) {
  return request(`${preUrlOfSponsor}/adCreative/query/list`, {
    method: "POST",
    body: params,
  });
}

export async function exportCreativity(params) {
  return request(`${preUrlOfSponsor}/adCreative/exportByDay`, {
    method: "POST",
    body: params,
  });
}

export async function getExportCreativityStatus(params) {
  return request(`${preUrlOfSponsor}/adCreative/getExportStatus`, {
    method: "POST",
    body: params,
  });
}

export async function cancelExportAdPlan(params) {
  return request(`${preUrlOfSponsor}/adPlan/killExportTask`, {
    method: "POST",
    body: params,
  });
}


export async function getExportAdPlanReportStatus(params) {
  return request(`${preUrlOfSponsor}/adplan/getExportStatusTable`, {
    method: "POST",
    body: params,
  });
}

export async function cancelExportCreativity(params) {
  return request(`${preUrlOfSponsor}/adCreative/killExportTask`, {
    method: "POST",
    body: params,
  });
}

export async function pauseAdCreativity(params) {
  return request(`${preUrlOfSponsor}/adCreative/update/pause`, {
    method: "POST",
    body: params,
  });
}

export async function serveAdCreativity(params) {
  return request(`${preUrlOfSponsor}/adCreative/update/serve`, {
    method: "POST",
    body: params,
  });
}

export async function removeAdCreativity(params) {
  return request(`${preUrlOfSponsor}/creative/delete`, {
    method: "POST",
    body: params,
  });
}

export async function editExposureMonitorLink(params) {
  return request(`${preUrlOfSponsor}/creative/exposureMonitor/edit`, {
    method: "POST",
    body: params,
  });
}

export async function editClickMonitorLink(params) {
  return request(`${preUrlOfSponsor}/creative/clickMonitor/edit`, {
    method: "POST",
    body: params,
  });
}

export async function editPlayMonitorLink(params) {
  return request(`${preUrlOfSponsor}/creative/videoPlayMonitor/edit`, {
    method: "POST",
    body: params,
  });
}

export async function editActiveMonitorLink(params) {
  return request(`${preUrlOfSponsor}/creative/effectTouchMonitor/edit`, {
    method: "POST",
    body: params,
  });
}


/* promote end */

/* step start */

export async function fetchPlanOption(params) {
  return request(`${preUrlOfSponsor}/adPlan/query/detailList`, {
    method: "POST",
    body: params,
  });
}

export async function createPlan(params) {
  return request(`${preUrlOfSponsor}/adPlan/create`, {
    method: "POST",
    body: params,
  });
}

export async function fetchPackageOption(params) {
  return request(`${preUrlOfSponsor}/campaignPackage/query/list`, {
    method: "POST",
    body: params,
  });
}

// 新建/编辑 动作文案是否出现 
export async function eventContentRequired(params) {
  return request(`${preUrlOfSponsor}/campaignPackage/info`, {
    method: 'POST',
    body: params,
  }); 
}

export async function fetchProductInfo(params) {
  return request(`${preUrlOfSponsor}/adProductInfo/query/list`, {
    method: "POST",
    body: params,
  });
}

export async function createProductInfo(params) {
  return request(`${preUrlOfSponsor}/adProductInfo/create`, {
    method: "POST",
    body: params,
  });
}

export async function delProductInfo(params) {
  return request(`${preUrlOfSponsor}/adProductInfo/delete`, {
    method: "POST",
    body: params,
  });
}

export async function updateProductInfo(params) {
  return request(`${preUrlOfSponsor}/adProductInfo/update`, {
    method: "POST",
    body: params,
  });
}

export async function getNOSToken(params) {
  return request(`${preUrl}file/nos/token`, {
    method: "POST",
    body: params,
  });
}

export async function getMUSICToken(params) {
  return request(`${preUrlOfSponsor}/nos/file/token`, {
    method: "POST",
    body: params,
  });
}

export async function getNOSUrl(url, params) {
  return request(url, {
    method: "POST",
    body: params,
  });
}

export async function getPositionAdvisedPrice(params) {
  return request(`${preUrlOfSponsor}/campaignPackage/getAdvisedPrice`, {
    method: "POST",
    body: params,
  });
}

export async function createAd(params) {
  return request(`${preUrlOfSponsor}/adform/create`, {
    method: "POST",
    body: params,
  });
}

export async function getEffectsDeep(params) {
  return request(`${preUrlOfSponsor}/adform/effects/deep`, {
    method: "POST",
    body: params,
  });
}

export async function updateAd(params) {
  return request(`${preUrlOfSponsor}/adform/update`, {
    method: "POST",
    body: params,
  });
}

export async function listDynamicWords() {
  return request(`${preUrlOfSponsor}/adform/listDynamicWords`, {
    method: "POST",
  });
}

export async function searchMusicTopic(params) {
  return request(`${preUrlOfSponsor}/adform/topic/query`, {
    method: "POST",
    body: params,
  });
}

/* step end */
export async function fakeFinanceInfo() {
  return request("/api/fake_finance_info");
}

export async function fakeFinanceList() {
  return request("/api/fake_finance_list");
}

export async function fakeFinanceSubmit(params) {
  return request("/api/fake_finance_submit", {
    method: "POST",
    body: params,
  });
}

export async function editSponsorCostLimit(params) {
  return request(`${preUrlOfSponsor}/sponsor/fund/editCostLimit`, {
    method: "POST",
    body: params,
  });
}

/* promote start */
export async function fetchAudience(params) {
  return request(`${preUrlOfSponsor}/targetPackageInfo/query/list`, {
    method: "POST",
    body: params,
  });
}

export async function createAudience(params) {
  return request(`${preUrlOfSponsor}/targetPackageInfo/create`, {
    method: "POST",
    body: params,
  });
}

export async function updateAudience(params) {
  return request(`${preUrlOfSponsor}/targetPackageInfo/update`, {
    method: "POST",
    body: params,
  });
}

export async function deleteAudience(params) {
  return request(`${preUrlOfSponsor}/targetPackageInfo/delete`, {
    method: "POST",
    body: params,
  });
}

/* promote end */

/* 转化跟踪 start */
export async function fetchConversion(body) {
  return request(`${preUrlOfSponsor}/conversion-tracking/query/list`, {
    method: "POST",
    body,
  });
}

export async function fetchWebConversionConstant(body) {
  return request(`${preUrlOfSponsor}/conversion-tracking/effects-web`, {
    method: "POST",
    body,
  });
}

// api线索转化 微信小程序 转化目标
export async function fetchWechatConversionConstant(params) {
  return request(`${preUrlOfSponsor}/conversion-tracking/effects-wechat`, {
    method: 'POST',
    body: params,
  }); 
}

export async function fetchApiWebConversionConstant(body) {
  return request(`${preUrlOfSponsor}/conversion-tracking/effects-webapi`, {
    method: "POST",
    body,
  });
}

export async function deleteConversion(body) {
  return request(`${preUrlOfSponsor}/conversion-tracking/delete`, {
    method: "POST",
    body,
  });
}

export async function fetchWebConversionDebugResult(body) {
  return request(`${preUrlOfSponsor}/conversion-tracking/query/debug-result`, {
    method: "POST",
    body,
  });
}

export async function getConversionDebugResult(body) {
  return request(`${preUrlOfSponsor}/conversion-tracking/urlsample`, {
    method: "POST",
    body,
  });
}

export async function getQueryName(body) {
  return request(`${preUrlOfSponsor}/conversion-tracking/query/name`, {
    method: "POST",
    body,
  });
}

export async function fetchEffects(body) {
  return request(`${preUrlOfSponsor}/conversion-tracking/effects`, {
    method: "POST",
    body,
  });
}

export async function fetchEffectsEvoke(body) {
  return request(`${preUrlOfSponsor}/conversion-tracking/effects-evoke`, {
    method: "POST",
    body,
  });
}

export async function updateStatus(body) {
  return request(`${preUrlOfSponsor}/conversion-tracking/update/status`, {
    method: "POST",
    body,
  });
}

export async function createConversion(body) {
  return request(`${preUrlOfSponsor}/conversion-tracking/create`, {
    method: "POST",
    body,
  });
}
export async function editConversion(body) {
  return request(`${preUrlOfSponsor}/conversion-tracking/update/name`, {
    method: "POST",
    body,
  });
}
export async function checkIfCanOpenDebugSwitch(body) {
  return request(`${preUrlOfSponsor}/conversion-tracking/update/check`, {
    method: "POST",
    body,
  });
}
export async function updateDebugStatus(body) {
  return request(`${preUrlOfSponsor}/conversio-tracking/update/edit-debug`, {
    method: "POST",
    body,
  });
}
export async function refreshClickEventReq(body) {
  return request(`${preUrlOfSponsor}/conversion-tracking/query/click-req`, {
    method: "POST",
    body,
  });
}
export async function refreshClickEventRes(body) {
  return request(`${preUrlOfSponsor}/conversion-tracking/query/click-res`, {
    method: "POST",
    body,
  });
}
/* 转化跟踪 end */

/* AccountCenter */
export async function bindAccount(params) {
  return request(`${preUrlOfSponsor}/cloudmusic/account/bind`, {
    method: "POST",
    body: params,
  });
}

export async function queryAccountHistory(params) {
  return request(`${preUrlOfSponsor}/cloudmusic/account/history`, {
    method: "POST",
    body: params,
  });
}

export async function getAccountBindInfo(params) {
  return request(`${preUrlOfSponsor}/cloudmusic/account/infoBinding`, {
    method: "POST",
    body: params,
  });
}

export async function getLogContant() {
  return request(`${preUrlOfSponsor}/operateRecord/queryConstant`, {
    method: "POST",
  });
}

export async function getLogList(params) {
  return request(`${preUrlOfSponsor}/operateRecord/queryList`, {
    method: "POST",
    body: params,
  });
}

export async function queryProjectNotice() {
  return request("/api/project/notice");
}

export async function queryActivities() {
  return request("/api/activities");
}

export async function queryRule(params) {
  return request(`/api/rule?${stringify(params)}`);
}

export async function removeRule(params) {
  return request("/api/rule", {
    method: "POST",
    body: {
      ...params,
      method: "delete",
    },
  });
}

export async function addRule(params) {
  return request("/api/rule", {
    method: "POST",
    body: {
      ...params,
      method: "post",
    },
  });
}

export async function fakeSubmitForm(params) {
  return request("/api/forms", {
    method: "POST",
    body: params,
  });
}

export async function queryTags() {
  return request("/api/tags");
}

export async function queryBasicProfile() {
  return request("/api/profile/basic");
}

export async function queryAdvancedProfile() {
  return request("/api/profile/advanced");
}

export async function queryFakeList(params) {
  return request(`/api/fake_list?${stringify(params)}`);
}

export async function fakeAccountLogin(params) {
  return request("/api/login/account", {
    method: "POST",
    body: params,
  });
}

export async function fakeMobileLogin(params) {
  return request("/api/login/mobile", {
    method: "POST",
    body: params,
  });
}

export async function fakeRegister(params) {
  return request("/api/register", {
    method: "POST",
    body: params,
  });
}

export async function queryNotices() {
  return request("/api/notices");
}

export async function queryBrand(params) {
  return request(`${preUrlOfSponsor}/brandLogo/queryLastOne`, {
    method: "POST",
    body: params,
  });
}

export async function saveBrand(params) {
  return request(`${preUrlOfSponsor}/brandLogo/save`, {
    method: "POST",
    body: params,
  });
}

// apk包管理中心接口

export async function updateAdFormAPK(data) {
  return request(`${preUrlOfSponsor}/apk/updateAdFormAPK`, {
    method: "POST",
    body: data,
  });
}

export async function queryAdFormByApk(data) {
  return request(`${preUrlOfSponsor}/apk/queryAdFormByApk`, {
    method: "POST",
    body: data,
  });
}

export async function updateAPkName(data) {
  return request(`${preUrlOfSponsor}/apk/updateName`, {
    method: "POST",
    body: data,
  });
}

export async function updatePackageName(data) {
  return request(`${preUrlOfSponsor}/apk/updatePackageName`, {
    method: "POST",
    body: data,
  });
}

export async function updateAPkVersion(data) {
  return request(`${preUrlOfSponsor}/apk/updateAPKVersion`, {
    method: "POST",
    body: data,
  });
}

export async function updateApkInfo(data) {
  return request(`${preUrlOfSponsor}/apk/update`, {
    method: "POST",
    body: data,
  });
}

export async function createAPK(data) {
  return request(`${preUrlOfSponsor}/apk/create`, {
    method: "POST",
    body: data,
  });
}

export async function deleteAPK(data) {
  return request(`${preUrlOfSponsor}/apk/delete`, {
    method: "POST",
    body: data,
  });
}

export async function resubmitApk(data) {
  return request(`${preUrlOfSponsor}/apk/resubmit`, {
    method: "POST",
    body: data,
  });
}

export async function getAppAction(data) {
  return request(`${preUrlOfSponsor}/target/app/list`, {
    method: "POST",
    body: data,
  });
}

export async function getInteresList() {
  return request(`${preUrlOfSponsor}/target/interest/list`, {
    method: "POST",
  });
}

export async function getAppBehaviorList() {
  return request(`${preUrlOfSponsor}/target/app/listCategory`, {
    method: "POST",
  });
}

export async function getDefined() {
  return request(`${preUrlOfSponsor}/adform/effects`, {
    method: "POST",
  });
}

export async function getWechatAuth() {
  return request(`${preUrlOfSponsor}/adform/query/wechatAuth`, {
    method: "POST",
  });
}

export async function getAdPositionData(data) {
  return request(`${preUrlOfSponsor}/campaignPackageOfPosition/query/list`, {
    method: "POST",
    body: data,
  });
}

export const queryCustomList = economize(async (body) => {
  return request(`${preUrlOfSponsor}/common/query/customList`, {
    method: 'POST',
    body,
  })
})

export async function editCustomList(data) {
  return request(`${preUrlOfSponsor}/common/update/customList`, {
    method: "POST",
    body: data,
  });
}

// 日限额修改

export async function editDayLimit(data) {
  return request(`${preUrl}sponsor/adform/updateDailyCostLimit`, {
    method: "POST",
    body: data,
  });
}

export async function enablePreview(data) {
  return request(`${preUrlOfSponsor}/adform/adPreview/enablePreview`, {
    method: "POST",
    body: data,
  });
}

export async function disablePreview(data) {
  return request(`${preUrlOfSponsor}/adform/adPreview/closePreview`, {
    method: "POST",
    body: data,
  });
}

export async function createTemplate(data) {
  return request(`${preUrlOfSponsor}/template/create`, {
    method: "POST",
    body: data,
  });
}

export async function templateList(data) {
  return request(`${preUrlOfSponsor}/template/list`, {
    method: "POST",
    body: data,
  });
}

export async function fetchAccountDataReport(data) {
  return request(`${preUrlOfSponsor}/sponsor/query/table`, {
    method: "POST",
    body: data,
  });
}

export async function fetchCreativityReport(data) {
  return request(`${preUrlOfSponsor}/adCreative/query/table`, {
    method: "POST",
    body: data,
  });
}

export async function fetchAdFormReport(data) {
  return request(`${preUrlOfSponsor}/adform/query/table`, {
    method: "POST",
    body: data,
  });
}

export async function fetchAdplanReport(data) {
  return request(`${preUrlOfSponsor}/adplan/query/table`, {
    method: "POST",
    body: data,
  });
}

export async function fetchCreativityLine(data) {
  return request(`${preUrlOfSponsor}/adCreative/query/line`, {
    method: "POST",
    body: data,
  });
}

export async function fetchAdPlanLine(data) {
  return request(`${preUrlOfSponsor}/adplan/query/line`, {
    method: "POST",
    body: data,
  });
}

export async function fetchAdFormLine(data) {
  return request(`${preUrlOfSponsor}/adform/query/line`, {
    method: "POST",
    body: data,
  });
}

export async function exportAdFormReport(data) {
  return request(`${preUrlOfSponsor}/adform/exportTable`, {
    method: "POST",
    body: data,
  });
}

export async function exportCreativityReport(data) {
  return request(`${preUrlOfSponsor}/adCreative/exportTable`, {
    method: "POST",
    body: data,
  });
}

export async function exportAccountReport(data) {
  return request(`${preUrlOfSponsor}/sponsor/sponsorExportTable` , {
      method: "POST",
      body: data,
  })
}

export async function exportAdplanReport(data) {
  return request(`${preUrlOfSponsor}/adplan/exportTable`, {
    method: "POST",
    body: data,
  });
}

export async function getExportCreativityReportStatus(data) {
  return request(`${preUrlOfSponsor}/adCreative/getExportStatusTable`, {
    method: "POST",
    body: data,
  });
}

export async function getExportAdFormReportStatus(data) {
  return request(`${preUrlOfSponsor}/adform/getExportStatusTable`, {
    method: "POST",
    body: data,
  });
}

export async function fuzzyMatchCreativity(data) {
  return request(`${preUrlOfSponsor}/common/queryAdCreative`, {
    method: "POST",
    body: data,
  });
}

/* 受众报表start */
export async function fetchAudienceContant(data) {
  return request(`${preUrlOfSponsor}/audience/report/queryConstant`, {
    method: "POST",
    body: data,
  });
}

export async function fetchAudienceGraphicArea(data) {
  return request(`${preUrlOfSponsor}/audience/report/queryGraphicArea`, {
    method: "POST",
    // 186616/
    body: data,
  });
}

export async function fetchAudienceDetailContent(data) {
  return request(`${preUrlOfSponsor}/audience/report/queryDetailData`, {
    method: "POST",
    body: data,
  });
}

export async function exportAudiencesReport(data) {
  return request(`${preUrlOfSponsor}/audience/report/exportByDetailData`, {
    method: "POST",
    body: data,
  });
}

export async function exportHomeData(data) {
  return request(`${preUrlOfSponsor}/sponsor/exportTable`, {
    method: "POST",
    body: data,
  });
}

export async function getExportAudiencesReportStatus(data) {
  return request(`${preUrlOfSponsor}/audience/report/getExportStatus`, {
    method: "POST",
    body: data,
  });
}

export async function getExportHomeDataStatus(data) {
  return request(`${preUrlOfSponsor}/sponsor/getExportStatusTable`, {
    method: "POST",
    body: data,
  });
}

export async function cancelExportAudiences(data) {
  return request(`${preUrlOfSponsor}/audience/report/killExportTask`, {
    method: "POST",
    body: data,
  });
}

/* 受众报表end */
export async function cancelExportHomeData(params) {
  return request(`${preUrlOfSponsor}/sponsor/killExportTask`, {
    method: "POST",
    body: params,
  });
}

// ocpc
export async function getBidModeStatus() {
  return request(`${preUrlOfSponsor}/sponsor/isEnableOptimizeOCPC`, {
    method: "POST",
  });
}

export async function getCurrentStatus(params) {
  return request(`${preUrlOfSponsor}/adform/isAliveForPreOcpcSupport`, {
    method: "POST",
    body: params,
  });
}

export async function updateCustomPage(params) {
  return request(`${preUrlOfSponsor}/common/update/customPage`, {
    method: "POST",
    body: params,
  });
}

export async function getCustomPage(params) {
  return request(`${preUrlOfSponsor}/common/query/customPage`, {
    method: "POST",
    body: params,
  });
}

// constant tree
export async function getCreativeTree() {
  return request(`${preUrlOfSponsor}/creative/category/tree`, {
    method: 'POST',
  });
}

// 广告列表 广告样式、广告版位搜索
export async function getCampaignPackage(params) {
  return request(`${preUrlOfSponsor}/campaignPackage/query/list/simple`, {
    method: 'POST',
    body: params,
  });
}

export async function getCampaignPackageOfPosition(params) {
  return request(`${preUrlOfSponsor}/campaignPackageOfPosition/query/list/simple`, {
    method: 'POST',
    body: params,
  });
}
export async function updateBatchLimited(params) {
  return request(`${preUrlOfSponsor}/adform/batchUpdateDailyCostLimit`, {
    method: 'POST',
    body: params,
  }); 
}

export async function updateBatchCalendar(params) {
  return request(`${preUrlOfSponsor}/adform/update/serveTime`, {
    method: 'POST',
    body: params,
  }); 
}

export async function updateBatchTime(params) {
  return request(`${preUrlOfSponsor}/adform/update/serveSeries`, {
    method: 'POST',
    body: params,
  }); 
}

// 新建/编辑广告 文案落地页是否必填 
export async function monitorRequired(params) {
  return request(`${preUrlOfSponsor}/adform/monitorRequired`, {
    method: 'POST',
    body: params,
  }); 
}

// 校验url合法性
export async function checkUrl(params) {
  return request(`${preUrlOfSponsor}/common/check/url`, {
    method: 'POST',
    body: params,
  }); 
}

// 批量修改定向包
export async function updateBatchTargetingContent(params) {
  return request(`${preUrlOfSponsor}/adform/updateBatchTargetingContent`, {
    method: 'POST',
    body: params,
  }); 
}

// 批量修改日预算
export async function updateBatchBudget(params) {
  return request(`${preUrlOfSponsor}/adPlan/updatebatchbudget`, {
    method: 'POST',
    body: params,
  }); 
}

// 查询是否是有效触点监测
export async function getEffectTouch(params) {
  return request(`${preUrlOfSponsor}/adform/effectTouch`, {
    method: 'POST',
    body: params,
  }); 
}

// 白名单查询
export async function getCostEnsure(params) {
  return request(`${preUrlOfSponsor}/adform/costEnsure`, {
    method: 'POST',
    body: params,
  }); 
}

// 获取广告预览功能的二维码
export async function getAdPreviewCode(params) {
  return request(`${preUrlOfSponsor}/adform/adPreview/qrCode`, {
    method: 'POST',
    body: params,
  }); 
}

// 获取AIGC生成图片的常量
export async function getFactoryConstant(params) {
  return request(`${preUrlOfSponsor}/material/factory/constant`, {
    method: 'POST',
    body: params,
  }); 
}

// 获取落地页列表
export async function getLandingPageList(params) {
  return request(`${preUrlOfSponsor}/landingPage/list`, {
    method: 'POST',
    body: params,
  }); 
}

// 创建生成任务
export async function createFactoryTask(params) {
  return request(`${preUrlOfSponsor}/material/factory/task/create`, {
    method: 'POST',
    body: params,
  }); 
}

// 创建落地页
export async function createLandingPage(params) {
  return request(`${preUrlOfSponsor}/landingPage/create`, {
    method: 'POST',
    body: params,
  }); 
}

// 生成任务详情
export async function getFactoryDetail(params) {
  return request(`${preUrlOfSponsor}/material/factory/task/detail`, {
    method: 'POST',
    body: params,
  }); 
}

// 编辑落地页
export async function updateLandingPage(params) {
  return request(`${preUrlOfSponsor}/landingPage/update`, {
    method: 'POST',
    body: params,
  }); 
}


// 生成图片列表
export async function getFactoryList(params) {
  return request(`${preUrlOfSponsor}/material/factory/material/list`, {
    method: 'POST',
    body: params,
  }); 
}

// 发布落地页
export async function publishLandingPage(params) {
  return request(`${preUrlOfSponsor}//landingPage/publish`, {

    method: 'POST',
    body: params,
  }); 
}

// 选择图片
export async function selectFactoryImage(params) {
  return request(`${preUrlOfSponsor}/material/factory/task/select`, {
    method: 'POST',
    body: params,
  }); 
}

// 上传本地资源到图片或视频库
export async function uploadLocalSource(params) {
  return request(`${preUrlOfSponsor}/material/factory/upload`, {
    method: 'POST',
    body: params,
  }); 
}

// 批量删除
export async function deleteSource(params) {
  return request(`${preUrlOfSponsor}/material/factory/delete`, {
    method: 'POST',
    body: params,
  }); 
}

// 落地页组件创建
export async function createLandingPageComponent(params) {
  return request(`${preUrlOfSponsor}/landingPage/form/create`, {
    method: 'POST',
    body: params,
  }); 
}

// 落地页面组件列表
export async function getLandingPageComponentList(params) {
  return request(`${preUrlOfSponsor}/landingPage/form/list`, {
    method: 'POST',
    body: params,
  }); 
}

// 落地页组件编辑
export async function updateLandingPageComponent(params) {
  return request(`${preUrlOfSponsor}/landingPage/form/update`, {
    method: 'POST',
    body: params,
  }); 
}

// 落地页组件删除
export async function deleteLandingPageComponent(params) {
  return request(`${preUrlOfSponsor}/landingPage/form/delete`, {
    method: 'POST',
    body: params,
  }); 
}

// 落地页数据导出
export async function exportLandingPage(params) {
  return request(`${preUrlOfSponsor}/landingPage/form/result/exportTable`, {
    method: 'POST',
    body: params,
  }); 
}

// 落地页导出状态
export async function getLandingPageExportStatus(params) {
  return request(`${preUrlOfSponsor}/landingPage/form/result/getExportStatusTable`, {
    method: 'POST',
    body: params,
  }); 
}

// 落地页数据展示
export async function getLandingPageData(params) {
  return request(`${preUrlOfSponsor}/landingPage/form/result/list`, {
    method: 'POST',
    body: params,
  }); 
}

// 获取行业人群包列表
export async function getIndustryGroupPage(params) {
  return request(`${preUrlOfSponsor}/sponsor/industry/CustomAudience/page`, {
    method: 'POST',
    body: params,
  }); 
}

// 获取行业选项
export async function fetchIndustry(params) {
  return request(`${preUrlOfSponsor}/sponsor/queryIndustry`, {
    method: 'POST',
    body: params,
  }); 
}

export async function fetchCityConstant(params) {
  return request(`${preUrl}sponsor/common/constant/city`, {
    method: 'POST',
    body: params,
  });
}

export async function fetchPopupRead(params) {
  return request(`${preUrl}sponsor/sponsor/popupRead`, {
    method: 'POST',
    body: params,
  });
}

export async function fetchPopupList(params) {
  return request(`${preUrl}sponsor/sponsor/popupList`, {
    method: 'POST',
    body: params,
  });
}